export default __webpack_public_path__ + "static/media/cross.b09d083a.svg";